PJQ.constants.erpAdmin.features = {
    cont_comp: {
        canSuggestMatches: true,
        columns: (filter, provider, options) => {
            let columns;
            if (filter === 'readyToImport' || filter === 'archived') {
                columns = [
                    {
                        "data": "attributes.erpObject.data",
                        "title": "Number",
                        "width": "100px",
                        "render": (data, a, row) => {
                            return data?.externalNumber ?? data?.id ?? "";
                        }
                    },
                    {
                        "data": "attributes.relatedObjects.relatedItem.companyName",
                        "title": "Company",
                    },
                    {
                        "data": "attributes.relatedObjects.relatedItem.address1",
                        "title": "Address",
                        "width": "20%"
                    },
                    {
                        "data": "attributes.relatedObjects.relatedItem.city",
                        "title": "City",
                        "width": "10%"
                    },
                    {
                        "data": "attributes.relatedObjects.relatedItem.state",
                        "title": "State",
                        "width": "5%"
                    },
                    {
                        "data": "attributes.relatedObjects.relatedItem.zip",
                        "title": "Zip",
                        "width": "10%"
                    }
                ];

                if (options.suggestMatches) {
                    columns = _.union([{
                        "title": '<div class="text-align-center"><div class="pretty p-default p-smooth fs-18 m-0"><input type="checkbox" class="select-all-erp-items" /><div class="state p-primary ml-auto"><label class="wd-0">&nbsp;</label></div></div>',
                        "orderable": false,
                        "searchable": false,
                        "data": "attributes.erpObject",
                        "visible": filter !== 'archived',
                        "render": _.bind(function (erpObj, type, row) {
                            let checkedText = _.contains(options.selectedERPItems, row.cid) ? "checked" : "";

                            if (erpObj.internalId > 0) {
                                return "";
                            }

                            return ('<div class="text-align-center"><div class="pretty p-default p-smooth fs-18 m-0"><input type="checkbox" class="select-erp-item" ' + checkedText + ' data-cid="' + row.cid + '"/><div class="state p-primary"><label class="wd-0">&nbsp;</label></div></div></div>');
                        }, this),
                        "width": '2%'
                    },], columns, [{
                        "data": "attributes.erpObject.data",
                        "title": "JobPlanner Company",
                        // "width": "10%",
                        "render": (data, a, row) => {
                            if (data.suggestedId > 0) {
                                return '<b>' + data.companyName + ' (' + data.suggestedId.toString() + ')' + '</b>';
                            }
                            return '';
                        }
                    }])
                }

                columns.push({
                    "data": "attributes",
                    "title": "",
                    "orderable": false,
                    "width": "10%",
                    "render": (attr, a, row) => {
                        if (attr.erpObject.internalId > 0) {
                            return "<div class='text-align-center text-success'>Linked!</div>";
                        } else if (options.suggestMatches) {
                            return '<div class="d-flex justify-content-center align-content-center action-button-container"><button type="button" class="btn btn-outline-primary btn-link-suggested">Link</button></div>';
                        } else if (filter === 'archived') {
                            return '<div class="d-flex justify-content-center align-content-center action-button-container"><button type="button" class="btn btn-outline-primary btn-remove-from-archive">Restore</button></div>';
                        } else {
                            return '<div class="d-flex justify-content-center align-content-center action-button-container">' +
                                '<div class="btn-group vendor-group"> ' +
                                '<button type="button" class="btn btn-outline-primary dropdown-toggle mr-1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Import</button> ' +
                                '<div class="dropdown-menu">' +
                                '<a class="dropdown-item btn-link-vendor" href="javascript:void(0)">Link to Existing Company</a> ' +
                                '<a class="dropdown-item btn-add-vendor" href="javascript:void(0)">Create New Company</a> ' +
                                '</div>' +
                                '</div>' +
                                '<div class="btn-group btn-extra-actions"> ' +
                                '<button type="button" class="btn btn-outline-secondary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><i class="fas fa-ellipsis-vertical mr-1"></i></button> ' +
                                '<div class="dropdown-menu">' +
                                '<a class="dropdown-item btn-archive" href="javascript:void(0)">Archive</a> ' +
                                '</div>' +
                                '</div>' +
                                '</div>';
                        }
                    },
                });
                if (provider === PJQ.constants.integrations.providers.SAGE300) {
                    columns.unshift(
                        {
                            "data": "attributes.relatedObjects.relatedItem.externalNumber",
                            "title": "Code",
                            "width": "10%"
                        },
                    );
                }
            } else {
                columns = [
                    {
                        "data": "attributes.relatedObjects.relatedItem.companyName",
                        "title": "Company",
                        "width": "20%"
                    },
                    {
                        "data": "attributes.relatedObjects.relatedItem.address1",
                        "title": "Address",
                        "width": "20%"
                    },
                    {
                        "data": "attributes.relatedObjects.relatedItem.city",
                        "title": "City",
                        "width": "10%"
                    },
                    {
                        "data": "attributes.relatedObjects.relatedItem.state",
                        "title": "State",
                        "width": "5%"
                    },
                    {
                        "data": "attributes.relatedObjects.relatedItem.zip",
                        "title": "Zip",
                        "width": "10%"
                    }
                ]
            }
            return columns;
        }
    },
    project: {
        enabled: function (integration) {
            if (integration == null) {
                return false;
            }

            return integration.getSetting(PJQ.constants.integrations.settings.SYNC_PROJECTS) !== false;
        },
        columns: (filter, provider) => {
            let columns;
            if (filter === 'readyToImport' || filter === 'archived') {
                columns = [
                    {
                        "data": "attributes.erpObject.data",
                        "title": "Number",
                        "width": "100px",
                        "render": (data, a, row) => {
                            return data?.externalNumber ?? data?.id ?? "";
                        }
                    },
                    {
                        "data": "attributes.relatedObjects.relatedItem.name",
                        "title": "Project Name",
                    },
                    {
                        "data": "attributes.relatedObjects.relatedItem.city",
                        "title": "City",
                        "width": "25%"
                    },
                    {
                        "data": "attributes.relatedObjects.relatedItem.state",
                        "title": "State",
                        "width": "10%"
                    },
                    {
                        "data": "",
                        "title": "",
                        "orderable": false,
                        "width": "10%",
                        "render": (data, a, row) => {
                            if (filter === 'archived') {
                                return '<div class="d-flex justify-content-center align-content-center action-button-container"><button type="button" class="btn btn-outline-primary btn-remove-from-archive">Restore</button></div>';
                            } else {
                                return '<div class="d-flex justify-content-center align-content-center action-button-container">' +
                                    '<div class="btn-group"> ' +
                                    '<button type="button" class="btn btn-outline-primary btn-add-project mr-1">Import</button>' +
                                    '</div>' +
                                    '<div class="btn-group btn-extra-actions"> ' +
                                    '<button type="button" class="btn btn-outline-secondary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><i class="fas fa-ellipsis-vertical mr-1"></i></button> ' +
                                    '<div class="dropdown-menu">' +
                                    '<a class="dropdown-item btn-archive" href="javascript:void(0)">Archive</a> ' +
                                    '</div>' +
                                    '</div>' +
                                    '</div>';
                            }
                        },
                    },
                ]

                if (provider === PJQ.constants.integrations.providers.SAGE300) {
                    columns.unshift(
                        {
                            "data": "attributes.relatedObjects.relatedItem.externalNumber",
                            "title": "Code",
                            "width": "10%"
                        },
                    );
                }
            } else {
                columns = [
                    {
                        "data": "attributes.relatedObjects.project.projectName",
                        "title": "Project",
                        "width": "25%",
                        "render": _.bind(function (data, a, row) {
                            return '<a class="view-item" target="_blank" href="#projects/' + row.attributes.relatedObjects.project.projectId + '">' + data + '</a>';
                        }, this),
                    },
                    {
                        "data": "attributes.relatedObjects.project.city",
                        "title": "City",
                        "width": "25%"
                    },
                    {
                        "data": "attributes.relatedObjects.project.state",
                        "title": "State",
                        "width": "25%"
                    },
                    {
                        "data": "attributes.relatedObjects.relatedItem.costCodeCount",
                        "title": "Cost Codes",
                        "width": "25%"
                    },
                ]
            }
            return columns;
        }
    },
    subjob: {
        columns: [
            {
                "data": "attributes.relatedObjects.relatedItem.externalNumber",
                "title": "Code",
                "width": "20%"
            },
            {
                "data": "attributes.relatedObjects.relatedItem.name",
                "title": "Name",
                "width": "30%"
            },
            {
                "data": "attributes.relatedObjects.relatedItem.description",
                "title": "Description",
                "width": "50%"
            }
        ]
    },
    costcode: {
        columns: (filter, provider, options) => {
            return [
                {
                    "title": '<div class="text-align-center"><div class="pretty p-default p-smooth fs-18 m-0"><input type="checkbox" class="select-all-erp-items" /><div class="state p-primary ml-auto"><label class="wd-0">&nbsp;</label></div></div>',
                    "orderable": false,
                    "searchable": false,
                    "visible": filter !== 'archived',
                    "render": _.bind(function (data, type, row) {
                        let checkedText = _.contains(options.selectedERPItems, row.cid) ? "checked" : "";

                        if (row.isImported) {
                            return "";
                        }

                        return ('<div class="text-align-center"><div class="pretty p-default p-smooth fs-18 m-0"><input type="checkbox" class="select-erp-item" ' + checkedText + ' data-cid="' + row.cid + '"/><div class="state p-primary"><label class="wd-0">&nbsp;</label></div></div></div>');
                    }, this),
                    "width": '2%'
                },
                {
                    "data": "attributes",
                    "title": "Code",
                    "width": "20%",
                    "render": function(data, type, row){
                        let item = row.attributes.relatedObjects.relatedItem;
                        return item?.externalNumber ?? item?.code ?? "";
                    }
                },
                {
                    "data": "attributes.relatedObjects.relatedItem.name",
                    "title": "Name",
                    "width": "30%"
                },
                {
                    "data": "",
                    "title": "",
                    "orderable": false,
                    "width": "10%",
                    "render": _.bind(function (data, a, row) {
                        if (filter === 'archived') {
                            return '<div class="d-flex justify-content-center align-content-center action-button-container"><button type="button" class="btn btn-outline-primary btn-remove-from-archive">Restore</button></div>';
                        } else {
                            if (row.isImported) {
                                return "<div class='text-align-center'><span class='text-success'>Cost Code Created!</span></div>"
                            }

                            return '<div class="d-flex justify-content-center align-content-center action-button-container">' +
                                '<div class="btn-group vendor-group"> ' +
                                '<button type="button" class="btn btn-outline-primary btn-add-cost-code mr-1">Import</button>' +
                                '</div>' +
                                '<div class="btn-group btn-extra-actions"> ' +
                                '<button type="button" class="btn btn-outline-secondary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><i class="fas fa-ellipsis-v mr-1"></i></button> ' +
                                '<div class="dropdown-menu">' +
                                '<a class="dropdown-item btn-archive" href="javascript:void(0)">Archive</a> ' +
                                '</div>' +
                                '</div>' +
                                '</div>';
                        }
                    }, this),
                }
            ];
        }
    },
    budget: {
        columns: [
            {
                "data": "attributes.relatedObjects.relatedItem.projectId",
                "title": "",
                "width": "10%",
                "render": _.bind(function (data, a, row) {
                    return '<a class="view-item" target="_blank" href="#projects/' + data + '/budget"> View Budget </a>';
                }, this),
            },
            {
                "data": "attributes.relatedObjects.project.projectName",
                "title": "Project",
                "width": "25%",
                "render": _.bind(function (data, a, row) {
                    return '<a class="view-item" target="_blank" href="#projects/' + row.attributes.relatedObjects.project.projectId + '">' + data + '</a>';
                }, this),
            },
            {
                "data": "attributes.relatedObjects.relatedItem.estimateAmount",
                "title": "Total Estimate",
                "width": "20%",
                "render": _.bind(function (data, a, row) {
                    return PJQ.helpers.formatHelpers.formatCurrency(data);
                }, this),
            }
        ]
    },
    contract: {
        enabled: function (integration) {
            if (integration == null) {
                return false;
            }

            return integration.getSetting(PJQ.constants.integrations.settings.SYNC_PRIME_CONTRACTS) !== false;
        },
        columns: [
            {
                "data": "attributes.relatedObjects.project.projectName",
                "title": "Project",
                "width": "20%",
                "render": _.bind(function (data, a, row) {
                    return '<a class="view-item" target="_blank" href="#projects/' + row.attributes.relatedObjects.project.projectId + '">' + data + '</a>';
                }, this),
            },
            {
                "data": "attributes.relatedObjects.relatedItem.number",
                "title": "Contract Number",
                "width": "15%",
                "render": _.bind(function (data, a, row) {
                    return '<a class="view-item" target="_blank" href="#projects/' + row.attributes.relatedObjects.project.projectId + '/contracts/' + row.attributes.relatedObjects.relatedItem.id + '">' + data + '</a>';
                }, this),
            },
            {
                "data": "attributes.relatedObjects.relatedItem.description",
                "title": "Description",
                "width": "20%",
            },
            {
                "data": "attributes.relatedObjects.relatedItem.totalAmount",
                "title": "Amount",
                "width": "10%",
                "render": _.bind(function (data, a, row) {
                    return PJQ.helpers.formatHelpers.formatCurrency(data);
                }, this),
            }
        ]
    },
    pcco: {
        enabled: function (integration) {
            if (integration == null) {
                return false;
            }

            return integration.getSetting(PJQ.constants.integrations.settings.SYNC_PRIME_CONTRACT_CHANGE_ORDERS) !== false;
        },
        columns: [
            {
                "data": "attributes.relatedObjects.project.projectName",
                "title": "Project",
                "width": "20%",
                "render": _.bind(function (data, a, row) {
                    return '<a class="view-item" target="_blank" href="#projects/' + row.attributes.relatedObjects.project.projectId + '">' + data + '</a>';
                }, this),
            },
            {
                "data": "attributes.relatedObjects.relatedItem.number",
                "title": "Number",
                "width": "10%",
                "render": _.bind(function (data, a, row) {
                    return '<a class="view-item" target="_blank" href="#projects/' + row.attributes.relatedObjects.project.projectId + '/contracts/changeorders/' + row.attributes.relatedObjects.relatedItem.id + '">' + data + '</a>';
                }, this),
            },
            {
                "data": "attributes.relatedObjects.relatedItem.description",
                "title": "Description",
                "width": "20%",
            },
            {
                "data": "attributes.relatedObjects.relatedItem.changeReason",
                "title": "Change Reason",
                "width": "20%",
            },
            {
                "data": "attributes.relatedObjects.relatedItem.totalAmount",
                "title": "Amount",
                "width": "10%",
                "render": _.bind(function (data, a, row) {
                    return PJQ.helpers.formatHelpers.formatCurrency(data);
                }, this),
            }
        ]
    },
    ar_inv: {
        enabled: function (integration) {
            if (integration == null) {
                return false;
            }

            return integration.getSetting(PJQ.constants.integrations.settings.SYNC_RECEIVABLE_INVOICES) !== false;
        },
        columns: [
            {
                "data": "attributes.relatedObjects.project.projectName",
                "title": "Project",
                "width": "20%",
                "render": _.bind(function (data, a, row) {
                    return '<a class="view-item" target="_blank" href="#projects/' + row.attributes.relatedObjects.project.projectId + '">' + data + '</a>';
                }, this),
            },
            {
                "data": "attributes.relatedObjects.relatedItem.number",
                "title": "Number",
                "width": "15%",
                "render": _.bind(function (data, a, row) {
                    return '<a class="view-item" target="_blank" href="#projects/' + row.attributes.relatedObjects.project.projectId + '/receivableinvoices/' + row.attributes.relatedObjects.relatedItem.id + '">' + data + '</a>';
                }, this),
            },
            {
                "data": "attributes.relatedObjects.relatedItem.billingDate",
                "title": "Due Date",
                "width": "15%",
                "render": _.bind(function (data, a, row) {
                    return PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                }, this),
            },
            {
                "data": "attributes.relatedObjects.relatedItem.totalAmount",
                "title": "Amount",
                "width": "15%",
                "render": _.bind(function (data, a, row) {
                    return PJQ.helpers.formatHelpers.formatCurrency(data);
                }, this),
            }
        ]
    },
    commitment: {
        enabled: function (integration) {
            if (integration == null) {
                return false;
            }

            return integration.getSetting(PJQ.constants.integrations.settings.SYNC_COMMITMENTS) !== false;
        },
        columns: [
            {
                "data": "attributes.relatedObjects.project.projectName",
                "title": "Project",
                "width": "20%",
                "render": _.bind(function (data, a, row) {
                    return '<a class="view-item" target="_blank" href="#projects/' + row.attributes.relatedObjects.project.projectId + '">' + data + '</a>';
                }, this),
            },
            {
                "data": "attributes.relatedObjects.relatedItem.number",
                "title": "Commitment Number",
                "width": "15%",
                "render": _.bind(function (data, a, row) {
                    return '<a class="view-item" target="_blank" href="#projects/' + row.attributes.relatedObjects.project.projectId + '/commitments/' + row.attributes.relatedObjects.relatedItem.id + '">' + data + '</a>';
                }, this),
            },
            {
                "data": "attributes.relatedObjects.relatedItem.description",
                "title": "Description",
                "width": "20%",
            },
            {
                "data": "attributes.relatedObjects.relatedItem.commitmentType",
                "title": "Type",
                "width": "10%",
                "render": _.bind(function (data, a, row) {
                    return PJQ.constants.commitments.commitmentTypeNames[data];
                }, this),
            },
            {
                "data": "attributes.relatedObjects.relatedItem.totalAmount",
                "title": "Amount",
                "width": "10%",
                "render": _.bind(function (data, a, row) {
                    return PJQ.helpers.formatHelpers.formatCurrency(data);
                }, this),
            }
        ]
    },
    cco: {
        enabled: function (integration) {
            if (integration == null) {
                return false;
            }

            return integration.getSetting(PJQ.constants.integrations.settings.SYNC_COMMITMENT_CHANGE_ORDERS) !== false;
        },
        columns: [
            {
                "data": "attributes.relatedObjects.project.projectName",
                "title": "Project",
                "width": "20%",
                "render": _.bind(function (data, a, row) {
                    return '<a class="view-item" target="_blank" href="#projects/' + row.attributes.relatedObjects.project.projectId + '">' + data + '</a>';
                }, this),
            },
            {
                "data": "attributes.relatedObjects.relatedItem.number",
                "title": "Number",
                "width": "10%",
                "render": _.bind(function (data, a, row) {
                    return '<a class="view-item" target="_blank" href="#projects/' + row.attributes.relatedObjects.project.projectId + '/commitments/changeorders/' + row.attributes.relatedObjects.relatedItem.id + '">' + data + '</a>';
                }, this),
            },
            {
                "data": "attributes.relatedObjects.relatedItem.description",
                "title": "Description",
                "width": "20%",
            },
            {
                "data": "attributes.relatedObjects.relatedItem.changeReason",
                "title": "Change Reason",
                "width": "20%",
            },
            {
                "data": "attributes.relatedObjects.relatedItem.totalAmount",
                "title": "Amount",
                "width": "10%",
                "render": _.bind(function (data, a, row) {
                    return PJQ.helpers.formatHelpers.formatCurrency(data);
                }, this),
            }
        ]
    },
    ap_inv: {
        enabled: function (integration) {
            if (integration == null) {
                return false;
            }

            return integration.getSetting(PJQ.constants.integrations.settings.SYNC_PAYABLE_INVOICES) !== false;
        },
        columns: [
            {
                "data": "attributes.relatedObjects.project.projectName",
                "title": "Project",
                "width": "20%",
                "render": _.bind(function (data, a, row) {
                    return '<a class="view-item" target="_blank" href="#projects/' + row.attributes.relatedObjects.project.projectId + '">' + data + '</a>';
                }, this),
            },
            {
                "data": "attributes.relatedObjects.relatedItem.number",
                "title": "Number",
                "width": "15%",
                "render": _.bind(function (data, a, row) {
                    return '<a class="view-item" target="_blank" href="#projects/' + row.attributes.relatedObjects.project.projectId + '/payableinvoices/' + row.attributes.relatedObjects.relatedItem.id + '">' + data + '</a>';
                }, this),
            },
            {
                "data": "attributes.relatedObjects.relatedItem.billingDate",
                "title": "Due Date",
                "width": "15%",
                "render": _.bind(function (data, a, row) {
                    return PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                }, this),
            },
            {
                "data": "attributes.relatedObjects.relatedItem.totalAmount",
                "title": "Amount",
                "width": "15%",
                "render": _.bind(function (data, a, row) {
                    return PJQ.helpers.formatHelpers.formatCurrency(data);
                }, this),
            }
        ]
    },
    d_cost: {
        enabled: function (integration) {
            if (integration == null) {
                return false;
            }

            return integration.getSetting(PJQ.constants.integrations.settings.SYNC_DIRECT_COSTS) !== false;
        },
        columns: [
            {
                "data": "attributes.relatedObjects.project.projectName",
                "title": "Project",
                "width": "20%",
                "render": _.bind(function (data, a, row) {
                    return '<a class="view-item" target="_blank" href="#projects/' + row.attributes.relatedObjects.project.projectId + '">' + data + '</a>';
                }, this),
            },
            {
                "data": "attributes.relatedObjects.relatedItem.type",
                "title": "Type",
                "width": "15%",
                "render": _.bind(function (data, a, row) {
                    return PJQ.constants.directcosts.directCostTypeNames[data]
                }, this),
            },
            {
                "data": "attributes.relatedObjects.relatedItem.description",
                "title": "Description",
                "width": "15%"
            },
            {
                "data": "attributes.relatedObjects.relatedItem.amount",
                "title": "Amount",
                "width": "15%",
                "render": _.bind(function (data, a, row) {
                    return PJQ.helpers.formatHelpers.formatCurrency(data);
                }, this),
            }
        ]
    }
}

PJQ.views.erpAdmin.ERPAdminManagement = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'erp-admin-management'),
        subTemplates: {
            approvalItem: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'erp-approval-item'),
            emptyQueue: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'empty-erp-queue'),
        },
    },
    events: {
        'click .btn-add-project': 'addProjectClicked',
        'click .btn-link-project': 'linkProjectClicked',
        'click .feature-nav-item a': 'featureChanged',
        'click .filter-nav-item a': 'filterChanged',
        'click .approve-button, .reject-button, .link-button': 'handleApprovalAction',
        'click .btn-submit-approve': 'approveItem',
        'click .btn-submit-reject': 'rejectItem',
        'click .btn-add-vendor': 'addVendorClicked',
        'click .btn-link-vendor': 'linkVendorClicked',
        'click .btn-refresh': 'refresh',
        'click .btn-archive': 'archiveClicked',
        'click .btn-remove-from-archive': 'removeFromArchiveClicked',
        'click .select-erp-item': 'erpItemSelected',
        'click .select-all-erp-items': 'selectAllERPItems',
        'click .btn-add-cost-code': 'addCostCodeClicked',
        'click .btn-import-items': 'addCostCodes',
        'change .cb-suggest-matches': 'suggestMatchesChanged',
        'click .btn-link-suggested': 'linkSuggestedClicked',
        'click .btn-link-all-suggested': 'linkAllSuggestedClicked',
        'click .btn-link-suggested-selected': 'linkSuggestedSelectedClicked',
    },
    beforeFirstRender: async function () {
        this.isFetched = false;
        this.erpIntegration = await PJQ.app.session.fetchERPIntegration();

        this.syncData = await this.erpIntegration.fetchSyncData();

        let defaultFeature = 'project',
            feature = this.options.feature ? this.options.feature : defaultFeature;
        this.provider = this.erpIntegration.getProvider();
        if (this.provider == null) {
            this.isFetched = true;
            this.render();
        }

        if (this.provider.erpAdmin.features[feature] == null) {
            feature = defaultFeature;
        }
        await this.changeFeature(feature);

        this.isFetched = true;
        this.render();
    },
    renderData: function () {
        return {
            isFetched: this.isFetched,
            features: this.getFeatures(),
            feature: this.feature,
            filter: this.filter,
            provider: this.provider
        }
    },
    getFeatures: function () {
        if (this.provider == null) {
            return {};
        } else {
            let res = {};
            _.each(this.provider.erpAdmin.features, (ftr, key) => {
                let feature = PJQ.constants.erpAdmin.features[key];
                if (feature == null) {
                    return;
                }

                if (typeof feature.enabled !== 'function' || feature.enabled(this.erpIntegration)) {
                    res[key] = ftr;
                }
            });
            return res;
        }
    },
    afterRender: function () {
        if (!this.isFetched) {
            return;
        }

        this.renderFeatureCounts();
        this.renderApprovalItems();
    },
    fetchERPObjects: async function () {
        return new Promise(async (resolve, reject) => {
            if (this.collection == null) {
                this.collection = new PJQ.collections.erpAdmin.ERPObjects();
            }
            this.collection.setInternalModel(this.feature);
            this.collection.setStatusIds(this.statusIds);

            await this.collection.fetch({
                data: {
                    externalModel: this.provider.erpAdmin.features[this.feature].externalModelName
                }
            }).fail((err) => {
                this.erpIntegration.handleError(err);
                reject(err);
            });
            resolve(true);
        });
    },
    featureChanged: async function (e) {
        let feature = $(e.currentTarget).data('feature');
        await this.changeFeature(feature);
        this.render();
    },
    changeFeature: async function (feature) {
        return new Promise(async (resolve) => {
            if (this.feature !== feature) {
                this.options.suggestMatches = false;

                let filters = this.provider.erpAdmin.features[feature].filters;
                this.feature = feature;
                this.filter = filters.readyToImport ? filters.readyToImport.name : filters.readyToExport.name;
                this.statusIds = filters.readyToImport ? [PJQ.constants.integrations.erp.syncStatuses.CACHED] : [PJQ.constants.integrations.erp.syncStatuses.REVIEWING]

                PJQ.app.router.navigate('erpadmin/' + this.feature, {
                    trigger: false
                });

                await this.fetchERPObjects().catch((err) => {
                    return;
                });

                let externalModel = this.provider.erpAdmin.features[this.feature].externalModelName;
                this.counts = await this.collection.getFeatureCounts(externalModel);
            }
            resolve(true);
        });
    },
    renderFeatureCounts: function () {
        _.each(this.provider.erpAdmin.features[this.feature].filters, function (filter) {
            let $el = this.$('.filter-count[data-filter="' + filter.name + '"]');

            switch (filter.name) {
                case 'readyToExport':
                    $el.text('(' + this.counts.readyToExportCount + ')');
                    break;
                case 'readyToImport':
                    $el.text('(' + this.counts.readyToImportCount + ')');
                    break;
                case 'failedToExport':
                    $el.text('(' + this.counts.failedToExportCount + ')');
                    break;
                case 'archived':
                    $el.text('(' + this.counts.archivedCount + ')');
                    break;
                default:
                    $el.text('(0)');
            }
        }, this)
    },
    filterChanged: async function (e) {
        let filter = $(e.currentTarget).data('filter'),
            statusIds = [];

        if (this.filter !== filter) {
            switch (filter) {
                case 'readyToImport':
                    this.filter = 'readyToImport';
                    break;
                case 'readyToExport':
                    this.filter = 'readyToExport';
                    statusIds.push(PJQ.constants.integrations.erp.syncStatuses.REVIEWING)
                    break;
                case 'failedToExport':
                    this.filter = 'failedToExport';
                    statusIds.push(PJQ.constants.integrations.erp.syncStatuses.FAILED)
                    break;
                case 'synced':
                    this.filter = 'synced';
                    statusIds.push(PJQ.constants.integrations.erp.syncStatuses.SYNCED)
                    break;
                case 'archived':
                    this.filter = 'archived';
                    break;
                default:
                    this.filter = 'readyToExport';
                    statusIds.push(PJQ.constants.integrations.erp.syncStatuses.REVIEWING)
                    break;
            }
            this.statusIds = statusIds;
            await this.fetchERPObjects();
            this.render();
        }
    },
    renderApprovalItems: function () {
        let $featurePane = this.$('.' + this.feature + '-pane');

        $featurePane.empty();

        this.options.selectedERPItems = [];
        this.filteredModels = [];

        // Add View Header
        if (_.size(this.collection.models) > 0) {
            let featureName = this.provider.erpAdmin.features[this.feature].displayName,
                filterName = this.provider.erpAdmin.features[this.feature].filters[this.filter].displayName,
                providerName = this.provider.displayName;
            $featurePane.append($('<div>').addClass('fs-14 font-italic border-bottom border-light view-header mb-2').text(providerName + ': ' + featureName + ' ' + filterName));
        }

        let fnRenderEmptyQueue = () => {
            this.renderSubTemplate(true, this.options.subTemplates.emptyQueue, $featurePane, {
                feature: this.feature,
                filter: this.filter,
                provider: this.provider
            }, () => {
            });
        }

        // Render View
        if (this.filter !== 'readyToImport' && this.filter !== 'archived' && _.size(this.collection.models) > 0) {
            // Group Models. Currently only supports grouping by project
            let groupedModels = _.groupBy(this.collection.models, model => {
                return model.project ? model.project.id : null;
            });

            _.each(groupedModels, (models, projectId) => {
                if (projectId !== 'null') {
                    let project = models[0].project;

                    $featurePane.append($('<div>').addClass('fs-18 font-weight-bold mt-3').text(project.projectName));
                }

                _.each(models, (model) => {
                    let $approvalItemOuter = $('<div>').addClass('approval-item-outer mb-2').attr('data-cid', model.cid);

                    $featurePane.append($approvalItemOuter);
                    this.renderApprovalItem(model);
                });
            });
        } else if (_.size(this.collection.models) > 0) {
            this.filteredModels = _.filter(this.collection.models, function (model) {
                let match = false,
                    statusId = model.get('erpObject').status;
                if (this.filter === 'archived') {
                    match = statusId === PJQ.constants.integrations.erp.syncStatuses.ARCHIVED;
                } else if (this.filter === 'readyToImport') {
                    match = statusId === PJQ.constants.integrations.erp.syncStatuses.CACHED;
                }

                if (this.options.suggestMatches) {
                    match = model.attributes.erpObject.data.suggestedId > 0;
                }

                return match;
            }, this);

            if (_.size(this.filteredModels) > 0 || this.options.suggestMatches) {
                this.renderSubTemplate(true, this.options.subTemplates.approvalItem, $featurePane, {
                    provider: this.provider,
                    feature: this.feature,
                    model: null,
                    relatedItem: null,
                    filter: this.filter,
                    inputs: null,
                    syncData: this.syncData,
                    options: this.options
                }, (item) => {
                    let columns = this.getColumns(),
                        ftr = this.provider.erpAdmin.features[this.feature];
                    this.itemTable = new PJQ.views.dataTables.DataTable({
                        el: this.$(item).find('.item-table'),
                        data: this.filteredModels,
                        rowId: "cid",
                        language: {
                            emptyTable: 'No ' + ftr.displayName + ' were found',
                            zeroRecords: 'No ' + ftr.displayName + ' matched the search criteria'
                        },
                        isHideSearch: false,
                        paging: true,
                        order: [1, 'asc'],
                        columns: columns,
                        contextMenuOptions: {
                            actions: this.filter !== 'archived' ? [
                                {
                                    name: 'Import',
                                    isShown: () => {
                                        return this.feature !== 'cont_comp' && this.filter !== 'archived';
                                    },
                                    onClick: (row) => {
                                        switch (this.feature) {
                                            case 'project':
                                                this.addProject(row.data());
                                                break;
                                            case 'costcode':
                                                this.addCostCode(row.data());
                                                break;
                                        }
                                    }
                                },
                                {
                                    name: 'Create New Company',
                                    isShown: () => {
                                        return this.feature === 'cont_comp' && this.filter !== 'archived';
                                    },
                                    onClick: (row) => {
                                        this.addVendor(row.data());
                                    }
                                },
                                {
                                    name: 'Link to Existing Company',
                                    isShown: () => {
                                        return this.feature === 'cont_comp' && this.filter !== 'archived';
                                    },
                                    onClick: (row) => {
                                        this.linkVendor(row.data());
                                    }
                                },
                                {
                                    name: 'Archive',
                                    isDanger: true,
                                    isShown: (row) => {
                                        return this.filter !== 'archived';
                                    },
                                    onClick: (row) => {
                                        this.archive(row.data());
                                    }
                                }
                            ] : [
                                {
                                    name: 'Restore',
                                    isShown: (row) => {
                                        return this.filter === 'archived';
                                    },
                                    onClick: (row) => {
                                        this.removeFromArchive(row.data());
                                    }
                                }
                            ]
                        },
                    });
                });
            } else {
                fnRenderEmptyQueue();
            }
        } else {
            fnRenderEmptyQueue();
        }
    },
    renderApprovalItem: function (model) {
        // Find the existing approval-item-outer div using the cid
        let $approvalItemOuter = this.$('.approval-item-outer[data-cid="' + model.cid + '"]');

        // If the div was found, proceed to render the item
        if ($approvalItemOuter.length > 0) {
            let inputs = this.provider.erpAdmin.features[this.feature].approvalInputs
            this.renderSubTemplate(false, this.options.subTemplates.approvalItem, $approvalItemOuter, {
                provider: this.provider,
                feature: this.feature,
                model: model,
                relatedItem: model.relatedItem,
                project: model.project,
                filter: this.filter,
                inputs: inputs,
                syncData: this.syncData,
            }, _.bind(function (item) {
                let columns = this.getColumns();
                item.dataTable = new PJQ.views.dataTables.DataTable({
                    el: this.$(item).find('.item-table'),
                    data: [model],
                    rowId: "cid",
                    isHideSearch: true,
                    paging: false,
                    order: [0, 'asc'],
                    columns: columns
                });

                _.each(inputs, function (input) {
                    let field = this.$(item).find('.' + input.className);
                    if (input.type === 'date') {
                        new PJQ.inputs.Datepicker({
                            el: field,
                            datepickerOptions: {
                                format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                                defaultDate: null
                            }
                        });
                    } else {
                        if (input.format) {
                            let mask = '';
                            if (input.prefix)
                                mask += "\\" + input.prefix;

                            if (input.format)
                                mask += input.format;

                            field.inputmask({
                                definitions: {
                                    '#': {
                                        validator: "[^]"
                                    }
                                },
                                mask: mask,
                                placeholder: ''
                            });
                        }
                    }
                }, this)
            }, this));
        }
    },
    handleApprovalAction: function (e) {
        let $target = $(e.currentTarget),
            value = $target.text().trim().toLowerCase(),
            $approvalItem = $target.closest('.approval-item'),
            cid = $approvalItem.data('cid'),
            model = this.collection.get(cid);

        // hide all context containers
        $approvalItem.find('.approve-context-container, .reject-context-container').hide().removeClass('d-flex');
        $approvalItem.find('.approve-button, .reject-button').addClass('inactive');

        // show the one that corresponds to the clicked button
        if (value === 'approve') {
            $target.removeClass('inactive');
            $approvalItem.find('.reject-button').addClass('inactive');
            $approvalItem.find('.link-button').addClass('inactive');
            let $approveContainer = $approvalItem.find('.approve-context-container');
            $approveContainer.addClass('d-flex').slideDown(200);
        } else if (value === 'reject') {
            $target.removeClass('inactive')
            $approvalItem.find('.approve-button').addClass('inactive');
            $approvalItem.find('.link-button').addClass('inactive');
            $approvalItem.find('.reject-context-container').slideDown(200);
        } else {
            $target.removeClass('inactive')
            $approvalItem.find('.approve-button').addClass('inactive');
            $approvalItem.find('.reject-button').addClass('inactive');

            new PJQ.views.erpAdmin.SelectImportVendorModal({
                isSingleChoice: true,
                provider: this.provider,
                onSave: _.bind(function (erpVendor) {
                    new PJQ.views.modals.YesNo({
                        header: "Link Vendor",
                        body: "Are you sure you would like to link this vendor to " + erpVendor.relatedItem.companyName + "?",
                        onYes: () => {
                            model.linkContactCompany(model.relatedItem, erpVendor.erpObject.externalId, _.bind(function (contactCompany, err) {
                                if (contactCompany && contactCompany.externalObject && contactCompany.externalObject.status === PJQ.constants.integrations.erp.syncStatuses.SYNCED) {
                                    contactCompany.erpObject = contactCompany.externalObject;
                                    model.set({
                                        isApproved: true
                                    });
                                    model.erpObject = contactCompany.externalObject;
                                    model.erpObject.successText = "Company Linked!";
                                    this.renderApprovalItem(model);
                                } else {
                                    model.erpObject.error = err ? err : contactCompany.error;
                                }
                                this.renderApprovalItem(model);
                            }, this));
                        },
                        onNo: () => {
                            $target.addClass('inactive')
                        },
                    });
                }, this)
            });
        }
    },
    approveItem: function (e) {
        let $target = $(e.currentTarget),
            approveContainer = $(e.target).closest('.approve-context-container'),
            cid = $target.closest('.approval-item').data('cid'),
            model = this.collection.get(cid),
            isValid = true,
            data = {};

        if (_.size(model.erpObject.externalId) === 0) {
            _.each(this.provider.erpAdmin.features[this.feature].approvalInputs, function (input) {
                let inputEl = approveContainer.find('.' + input.className),
                    inputValue = inputEl.val();
                if (_.size(inputValue) > 0) {
                    data[input.value] = inputValue
                } else if (input.required) {
                    isValid = false;
                    PJQ.helpers.inputHelpers.setInputError(inputEl, false);
                }
            }, this);
        } else {
            data = model.erpObject.data;
        }

        if (isValid) {
            let loader = new PJQ.Loader($target.closest('.approval-item'));
            model.approve(data, (res, err) => {
                loader.remove();
                if (res == null) {
                    this.erpIntegration.handleError(err);
                    return;
                }

                if (res && !res.error) {
                    model.set('isApproved', true);
                    this.renderApprovalItem(model);
                } else {
                    model.erpObject.error = res ? res.error : 'Something went wrong'
                    this.renderApprovalItem(model);
                }
            });
        }
    },
    rejectItem: function (e) {
        let $target = $(e.currentTarget),
            $approvalItem = $target.closest('.approval-item'),
            cid = $approvalItem.data('cid'),
            model = this.collection.get(cid),
            isValid = true,
            rejectReason = $approvalItem.find('.reject-reason').val();

        if (isValid) {
            let loader = new PJQ.Loader($approvalItem);
            model.reject(rejectReason, (res) => {
                loader.remove();
                this.renderApprovalItem(model);
            });
        }
    },
    getColumns: function () {
        let ftr = this.feature.toLowerCase(),
            cols = PJQ.constants.erpAdmin.features[ftr].columns;
        return typeof cols === 'function' ? cols(this.filter, this.provider, this.options) : cols;
    },
    erpItemSelected: function (e) {
        if (this.options.selectedERPItems == null) {
            this.options.selectedERPItems = [];
        }

        let $target = $(e.currentTarget),
            cid = $target.data('cid'),
            isChecked = $target.prop('checked');
        if (_.size(cid) > 0) {
            if (isChecked) {
                this.options.selectedERPItems.push(cid);
            } else {
                this.options.selectedERPItems = _.reject(this.options.selectedERPItems, function (sCid) {
                    return sCid === cid;
                });
            }
        }

        this.$('.select-all-erp-items').prop('checked', _.size(this.options.selectedERPItems) === _.size(this.filteredModels) && _.size(this.filteredModels) > 0);

        this.handleSelectedERPItemsButtons();
    },
    selectAllERPItems: function (e) {
        let $target = $(e.currentTarget),
            isChecked = $target.prop('checked');

        if (!isChecked || this.options.selectedERPItems == null) {
            this.options.selectedERPItems = [];
        }

        _.each(this.filteredModels, function (model) {
            let checkbox = this.$('.select-erp-item[data-cid="' + model.cid + '"]');

            if (!isChecked) {
                checkbox.prop('checked', false);
            } else {
                checkbox.prop('checked', true);

                if (!_.contains(this.options.selectedERPItems, model.cid)) {
                    this.options.selectedERPItems.push(model.cid);
                }
            }
        }, this);

        this.handleSelectedERPItemsButtons();
    },
    handleSelectedERPItemsButtons: function (alteredModel) {
        // if a model was passed in, it was archived, or imported, so remove it from the filtered models and selected items if it exists there.
        if (alteredModel) {
            this.filteredModels = _.reject(this.filteredModels, function (m) {
                return m === alteredModel;
            });
            this.options.selectedERPItems = _.reject(this.options.selectedERPItems, function (cid) {
                return cid === alteredModel.cid;
            });
        }

        this.$('.select-all-erp-items').prop('checked', _.size(this.options.selectedERPItems) === _.size(this.filteredModels) && _.size(this.filteredModels) > 0);
        this.$('.btn-for-selected').attr('disabled', _.size(this.options.selectedERPItems) === 0);
        this.$('.selected-items-count').text(_.size(this.options.selectedERPItems));
    },
    addVendorClicked: function (e) {
        let target = $(e.currentTarget),
            row = target.closest('tr'),
            cid = row[0].id,
            model = this.collection.get(cid);

        this.addVendor(model);
    },
    addVendor: function (model) {
        let rowEl = this.$('tr#' + model.cid),
            actionButtonContainer = rowEl.find('.action-button-container'),
            loader = new PJQ.Loader(actionButtonContainer),
            externalId = model.relatedItem.id;

        model.createNewContactCompany(externalId, _.bind(function (contactCompany, err) {
            loader.remove();
            if (contactCompany) {
                if (!contactCompany.error) {
                    actionButtonContainer.html("<span class='text-success'>Company Created!</span>");
                    this.counts.readyToImportCount--;
                    this.renderFeatureCounts();
                } else {
                    actionButtonContainer.html("<span class='text-danger'>" + err ? err : contactCompany.error + "</span>");
                }
            } else {
                PJQ.notifications.notify.errorNotify({
                    message: 'Failed to Import Contact'
                });
            }
        }, this));
    },
    linkVendorClicked: function (e) {
        let target = $(e.currentTarget),
            row = target.closest('tr'),
            cid = row[0].id,
            model = this.collection.get(cid);

        this.linkVendor(model);
    },
    linkVendor: function (model) {
        let rowEl = this.$('tr#' + model.cid),
            actionButtonContainer = rowEl.find('.action-button-container');

        new PJQ.views.contacts.SelectContactsModal({
            context: PJQ.constants.contacts.contexts.COMPANIES,
            isSingleChoice: true,
            displayContactsBlock: true,
            onSave: _.bind(function (selectedCompany) {
                let loader = new PJQ.Loader(actionButtonContainer);
                selectedCompany.set('companyId', selectedCompany.get('contactCompanyId'));
                model.linkContactCompany(selectedCompany, model.erpObject.externalId, _.bind(function (contactCompany, err) {
                    loader.remove();
                    if (contactCompany) {
                        if (!contactCompany.error) {
                            actionButtonContainer.html("<span class='text-success'>Company Linked!</span>");
                            this.counts.readyToImportCount--;
                            this.renderFeatureCounts();
                        } else {
                            actionButtonContainer.html("<span class='text-danger'>" + err ? err : contactCompany.error + "</span>");
                        }
                    } else {
                        PJQ.notifications.notify.errorNotify({
                            message: 'Failed to Import Contact'
                        });
                    }
                }, this));
            }, this)
        });
    },
    suggestMatchesChanged: function (e) {
        this.options.suggestMatches = $(e.currentTarget).prop('checked');
        this.render();
    },
    linkSuggestedSelectedClicked: function () {
        this.linkSuggested(null, this.collection.get(this.options.selectedERPItems));
    },
    linkSuggestedClicked: function (e) {
        let target = $(e.currentTarget),
            $row = target.closest('tr'),
            row = this.itemTable.getRow($row[0].id);
        this.linkSuggested(row);
    },
    linkAllSuggestedClicked: function () {
        if (null == _.find(this.collection.models, (obj) => {
            return obj.erpObject.data.suggestedId > 0 && !(obj.erpObject.internalId > 0);
        })) {
            return;
        }
        this.linkSuggested();
    },
    toggleLoader: function (show) {
        if (show == null) {
            show = this.loader != null;
        }

        if (show && this.loader == null) {
            this.loader = new PJQ.Loader(this.$('.erp-admin-nav'));
        } else if (!show && this.loader != null) {
            this.loader.remove();
            this.loader = null;
        }
    },
    linkSuggested: function (row, objs) {
        let linkObjs = null;
        if (row != null) {
            linkObjs = [row.data()];
        } else if (objs != null) {
            linkObjs = objs;
        }

        this.toggleLoader(true);

        let externalModel = this.provider.erpAdmin.features[this.feature].externalModelName;
        this.collection.linkSuggested(externalModel, linkObjs, (res) => {
            if (res) {
                if (res.error) {
                    return;
                }

                this.toggleLoader(false);

                let linkedCount = _.size(res);
                this.counts.readyToImportCount = this.counts.readyToImportCount - linkedCount;
                this.renderFeatureCounts();

                PJQ.notifications.notify.successNotify({
                    message: linkedCount.toString() + ' Contacts Linked to ERP'
                });

                if (row != null) {
                    // Remove from filtered models and selected items
                    this.handleSelectedERPItemsButtons(row.data());
                    this.itemTable.refreshRow(row);
                } else {
                    this.render();
                }
            } else {
                PJQ.notifications.notify.errorNotify({
                    message: 'Failed to Archive'
                });
            }
        });
    },
    archiveClicked: function (e) {
        let target = $(e.currentTarget),
            row = target.closest('tr'),
            cid = row[0].id,
            model = this.collection.get(cid);
        this.archive(model);
    },
    archive: function (model) {
        let rowEl = this.$('tr#' + model.cid),
            actionButtonContainer = rowEl.find('.action-button-container');

        model.archive(_.bind(function (res) {
            if (res) {
                if (!res.error) {
                    actionButtonContainer.html("<span class='text-success'>Archived!</span>");
                    this.counts.readyToImportCount--;
                    this.counts.archivedCount++;
                    this.renderFeatureCounts();
                    // Remove from filtered models and selected items
                    this.handleSelectedERPItemsButtons(model);
                } else {
                    actionButtonContainer.html("<span class='text-danger'>" + res.error + "</span>");
                }
                rowEl.find('.select-erp-item').closest('.text-align-center').remove();
            } else {
                PJQ.notifications.notify.errorNotify({
                    message: 'Failed to Archive'
                });
            }
        }, this));
    },
    removeFromArchiveClicked: function (e) {
        let target = $(e.currentTarget),
            row = target.closest('tr'),
            cid = row[0].id,
            model = this.collection.get(cid);

        this.removeFromArchive(model);
    },
    removeFromArchive: function (model) {
        let rowEl = this.$('tr#' + model.cid),
            actionButtonContainer = rowEl.find('.action-button-container');

        model.removeFromArchive(_.bind(function (res) {
            if (res) {
                if (!res.error) {
                    actionButtonContainer.html("<span class='text-success'>Restored!</span>");
                    this.counts.readyToImportCount++;
                    this.counts.archivedCount--;
                    this.renderFeatureCounts();
                } else {
                    actionButtonContainer.html("<span class='text-danger'>" + res.error + "</span>");
                }
            } else {
                PJQ.notifications.notify.errorNotify({
                    message: 'Failed to Restore'
                });
            }
        }, this));
    },
    addProjectClicked: function (e) {
        let target = $(e.currentTarget),
            row = target.closest('tr'),
            cid = row[0].id,
            model = this.collection.get(cid);

        this.addProject(model);
    },
    addProject: function (model) {
        let rowEl = this.$('tr#' + model.cid),
            actionButtonContainer = rowEl.find('.action-button-container');

        let loader = new PJQ.Loader(actionButtonContainer);

        model.pull((res) => {
            loader.remove();
            if (res) {
                let project = new PJQ.models.projects.Project(res);
                if (project.id > 0) {
                    project.save(null, {
                        success: () => {
                            actionButtonContainer.html("<div><div class='text-success'>Project Created!</div>" +
                                "<div><a class='btn btn-link btn-sm ml-2' href='#projects/" + project.id + "'>View Project</a></div></div>");
                            this.counts.readyToImportCount--;
                            this.renderFeatureCounts();
                        }
                    })
                } else {
                    actionButtonContainer.html("<span class='text-danger'>" + res.error + "</span>");
                }
            } else {
                PJQ.notifications.notify.errorNotify({
                    message: 'Failed to Import Project'
                });
            }
        });
    },
    linkProjectClicked: function (e) {
        let target = $(e.currentTarget),
            row = target.closest('tr'),
            cid = row[0].id,
            model = this.collection.get(cid);

        this.linkProject(model);
    },
    linkProject: function (model) {
        let rowEl = this.$('tr#' + model.cid),
            actionButtonContainer = rowEl.find('.action-button-container');


        // new PJQ.views.contacts.SelectContactsModal({
        //     context: PJQ.constants.contacts.contexts.COMPANIES,
        //     isSingleChoice: true,
        //     displayContactsBlock: true,
        //     onSave: _.bind(function (selectedCompany) {
        //         let loader = new PJQ.Loader(actionButtonContainer);
        //         selectedCompany.set('companyId', selectedCompany.get('contactCompanyId'));
        //         model.linkContactCompany(selectedCompany, model.erpObject.externalId, _.bind(function (contactCompany, err) {
        //             loader.remove();
        //             if (contactCompany) {
        //                 if (!contactCompany.error) {
        //                     actionButtonContainer.html("<span class='text-success'>Company Linked!</span>");
        //                     this.counts.readyToImportCount--;
        //                     this.renderFeatureCounts();
        //                 } else {
        //                     actionButtonContainer.html("<span class='text-danger'>" + err ? err : contactCompany.error + "</span>");
        //                 }
        //             } else {
        //                 PJQ.notifications.notify.errorNotify({
        //                     message: 'Failed to Import Contact'
        //                 });
        //             }
        //         }, this));
        //     }, this)
        // });
    },
    addCostCodeClicked: function (e) {
        let target = $(e.currentTarget),
            row = target.closest('tr'),
            cid = row[0].id,
            model = this.collection.get(cid);

        this.addCostCode(model);
    },
    addCostCode: function (model) {
        let rowEl = this.$('tr#' + model.cid),
            actionButtonContainer = rowEl.find('.action-button-container'),
            loader = new PJQ.Loader(actionButtonContainer);

        this.createNewCostCodes([model.get('erpObject').externalId], (res) => {
            loader.remove();
            if (res) {
                actionButtonContainer.html("<span class='text-success'>Cost Code Created!</span>");
                this.counts.readyToImportCount--;

                this.renderFeatureCounts();
                this.handleSelectedERPItemsButtons(model);
                rowEl.find('.select-erp-item').closest('.text-align-center').remove();
            } else {
                PJQ.notifications.notify.errorNotify({
                    message: 'Failed to Import Cost Code'
                });
            }
        });
    },
    addCostCodes: function () {
        let loader = new PJQ.Loader(this.$('.costcode-pane')),
            costCodes = [],
            costCodesExternalIds = [];

        _.each(this.options.selectedERPItems, _.bind(function (cid) {
            let model = this.collection.get(cid);
            costCodes.push(model);
            costCodesExternalIds.push(model.get('erpObject').externalId)
        }, this));


        this.createNewCostCodes(costCodesExternalIds, (res) => {
            _.each(costCodes, function (costCode) {
                this.filteredModels = _.reject(this.filteredModels, function (m) {
                    return m === costCode;
                });
                this.options.selectedERPItems = _.reject(this.options.selectedERPItems, function (cid) {
                    return cid === costCode.cid;
                });
                costCode.isImported = true;

                let rowEl = this.$('tr#' + costCode.cid);
                rowEl.find('.action-button-container').html("<span class='text-success'>Cost Code Created!</span>");
                rowEl.find('.select-erp-item').closest('.text-align-center').remove();
            }, this);
            loader.remove();
            this.handleSelectedERPItemsButtons();
        });

    },
    createNewCostCodes: function (externalIds, callback) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'erp'
                },
                {
                    endpoint: 'costcodes'
                },
                {
                    endpoint: 'pull'
                }]),
            data: externalIds,
            isAPIv2: true,
        }).post().done(_.bind(function (res) {
            if (typeof callback === 'function') {
                callback(res);
            }
        }, this)).fail(_.bind(function (error) {
            if (typeof callback === 'function') {
                callback(false, error);
            }
        }, this));
    },
    refresh: async function () {
        this.toggleLoader(true);
        await this.collection.refreshModels(this.provider.erpAdmin.features[this.feature].externalModelName + 's').catch((err) => {
            this.erpIntegration.handleError(err);
            this.toggleLoader(false);
            return;
        });

        let date = new Date();
        if (this.feature === this.provider.erpAdmin.features.project.internalModelName) {
            this.syncData.projectsSyncedOn = date.toISOString();
        } else if (this.feature === this.provider.erpAdmin.features.cont_comp.internalModelName) {
            this.syncData.vendorsSyncedOn = date.toISOString();
        } else if (this.feature === this.provider.erpAdmin.features.costcode.internalModelName) {
            this.syncData.costCodesSyncedOn = date.toISOString();
        }

        this.toggleLoader(false);
        await this.fetchERPObjects().catch((err) => {
            return;
        });
        this.render();
    }
});

PJQ.views.erpAdmin.SelectImportVendorModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'modal-select-import-vendor'),
        width: '60%',
        maxWidth: 700,
        onSave: _.noop,
        headerSubText: null
    },
    events: {
        "change .select-vendor": "selectVendor",
        "click .btn-save": "save",
        "click .btn-cancel": "cancel"
    },
    beforeModalCreated: function () {
        this.options.isAdmin = PJQ.app.session.hasPermission('settings.canManageERPAdmin');
        this.selectedVendors = [];

        if (this.collection == null) {
            this.collection = new PJQ.collections.erpAdmin.ERPObjects(null, {
                internalModel: this.options.provider.erpAdmin.features.cont_comp.internalModelName,
                statusIds: []
            });
        }

        if (this.collection.isFetched) {
            this.render();
        } else {
            this.collection.fetch({
                data: {
                    externalModel: this.options.provider.erpAdmin.features.cont_comp.externalModelName
                },
                success: _.bind(function () {
                    this.vendors = this.collection.models
                    this.render();
                }, this)
            });
        }
    },
    renderData: function () {
        return {
            headerSubText: this.options.headerSubText,
            isSingleChoice: this.options.isSingleChoice
        }
    },
    afterRender: function () {
        this.dataTable = new PJQ.views.dataTables.DataTable({
            el: this.$('.vendors-table'),
            data: this.vendors,
            order: [],
            columns: [{
                "data": "attributes.isSelected",
                "title": "",
                "orderable": false,
                "width": "7%",
                "searchable": false,
                "render": _.bind(function (data) {
                    return ('<div class="text-align-center"><div class="pretty p-default p-smooth fs-18 m-0"><input type="checkbox" ' + (data ? 'checked' : '') + ' class="select-vendor"/><div class="state p-primary"><label class="wd-0">&nbsp;</label></div></div></div>');
                }, this)
            },
                {
                    "data": "attributes.relatedObjects.relatedItem.companyName",
                    "title": "Company",
                    "width": "20%"
                },
                {
                    "data": "attributes.relatedObjects.relatedItem.address1",
                    "title": "Address",
                    "width": "20%"
                },
                {
                    "data": "attributes.relatedObjects.relatedItem.city",
                    "title": "City",
                    "width": "10%"
                },
                {
                    "data": "attributes.relatedObjects.relatedItem.state",
                    "title": "State",
                    "width": "5%"
                },
                {
                    "data": "attributes.relatedObjects.relatedItem.zip",
                    "title": "Zip",
                    "width": "10%"
                }
            ],
            dom: '<"top"<"clear">>rt<"bottom"p<"clear">>'
        });
    },
    selectVendor: function (e) {
        let target = $(e.currentTarget),
            vendor = this.dataTable.getRow(target.closest('tr')).data();

        if (this.options.isSingleChoice) {
            this.$('.select-vendor').not(target).text('Select').prop('checked', false);
            if (vendor.get('isSelected')) {
                vendor.set('isSelected', false);
                this.selectedVendor = null;
            } else {
                vendor.set('isSelected', true);
                this.selectedVendor = vendor;
                this.collection.get(vendor.id);
                _.each(this.collection.models, _.bind(function (dtVendor) {
                    if (vendor.id !== dtVendor.id)
                        dtVendor.set('isSelected', false);
                }, this));
            }
            this.$('.btn-save').attr('disabled', this.selectedVendor == null);

            if (typeof this.options.onVendorSelected === 'function') {
                this.options.onVendorSelected(this.selectedVendor);
            }
        } else {
            if (vendor.get('isSelected')) {
                target.text('Select').addClass('btn-primary').removeClass('btn-secondary');
                vendor.set('isSelected', false);
                this.selectedVendors = _.reject(this.selectedVendors, function (selVendor) {
                    return selVendor.id === vendor.id;
                });
            } else {
                target.text('Deselect').addClass('btn-secondary').removeClass('btn-primary');
                vendor.set('isSelected', true);
                this.selectedVendors.push(vendor);
            }
            this.$('.btn-save').attr('disabled', this.selectedVendors == null);

            if (typeof this.options.onVendorSelected === 'function') {
                this.options.onVendorSelected(this.selectedVendors);
            }
        }
    },
    cancel: function () {
        if (this.options.onCancel) {
            this.options.onCancel();
        }
        this.removeModal();
    },
    save: function () {
        if (this.options.onSave) {
            this.options.onSave(this.selectedVendor ? this.selectedVendor : this.selectedVendors);
            this.removeModal();
        }
    }
});